import { Network } from "../../.."
import store from "../../../../store"

export const BANK_ACCOUNT_TYPE = {
  CHECKING: "checking",
  SAVINGS: "savings"
}

export class BankAccount {
  constructor(attributes = {}) {
    Object.assign(this, attributes)

    const isProd = window.location.hostname === "my.salusion.com"
    if (!isProd && !this.routingNumber) this.routingNumber = "000000000"
  }

  static async getOne({ params }) {
    const { data: bankAccount } = await Network.AxiosWrapperV2.get({
      url: `bankAccount/${params.id}?includeNumbers=true`
    })
    return new BankAccount(bankAccount)
  }

  static async getAll({ options, params } = {}) {
    const { data } = await Network.AxiosWrapperV2.get({
      url: params ? `bankAccount?${params?.toString()}` : `bankAccount`
    })
    return new Map(
      data.reduce((arr, acc) => {
        if (acc.id === "payroll" && options?.includes("REMOVE_PAYROLL")) {
          return arr
        } else {
          return [...arr, [acc.id, new BankAccount(acc)]]
        }
      }, [])
    )
  }

  static async createOne({ data }) {
    try {
      const { data: bankAccountData } = await Network.AxiosWrapperV2.post({
        data,
        url: `bankAccount`
      })
      store.setNotification("notification", true, {
        msg: "Successfully created bank account."
      })
      return new BankAccount(bankAccountData)
    } catch (err) {
      console.error(err)
    }
  }

  get displayName() {
    return this.nickname
      ? `ACH (${this.bankName}${this.accountNumber ? " *" : ""}${String(this.accountNumber).slice(-3)})`
      : `ACH`
  }

  get bankNameFormatted() {
    return `${this.bankName} *${String(this.accountNumber).slice(-3)}`
  }

  async update({ data }) {
    try {
      if (this.links?.update) {
        const { data: bankAccountData } = await Network.AxiosWrapperV2.send({
          ...this.links.update,
          data
        })
        store.setNotification("notification", true, {
          msg: "Successfully updated bank account."
        })
        return new BankAccount(bankAccountData)
      }
    } catch (err) {
      console.error(err)
    }
  }

  async delete() {
    try {
      if (this.links?.delete) {
        await Network.AxiosWrapperV2.send({ ...this.links.delete })

        store.setNotification("notification", true, {
          msg: "Successfully deleted bank account."
        })

        return true
      }
    } catch (err) {
      console.error(err)
    }
    return false
  }
}

export default BankAccount
